export default __webpack_public_path__ + "static/Leaves-f92ca268160a0281f90799c05ee88c18.png";